<template>
  <div class="py-2">
    <v-hover
      v-slot:default="{ hover }"
      v-for="item in tabData.items"
      :key="item.id"
    >
      <v-card
        @click="handleClickItem(item)"
        :elevation="hover ? 8 : 2"
        max-width="400"
        class="mb-12 transition-swing ma-3"
      >
        <image-container :src-image="getImageById(item.id)" />
        <v-card-title v-if="item.title">
          {{ item.title }}
          <v-spacer></v-spacer>
          <dropdown-menu
            item-key-text="text"
            itemKeyValue="id"
            :items="item.contextMenu"
            @input="handleContext($event, item)"
          >
            <template v-slot:activator="{ on }">
              <slot name="activator" :on="on">
                <v-btn slot="activator" v-on="on" icon>
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </slot>
            </template>
          </dropdown-menu>
        </v-card-title>
        <v-card-subtitle class="pb-0">
          <span v-for="subtitle in item.subtitles" :key="subtitle">
            {{ subtitle }}
          </span>
        </v-card-subtitle>
        <v-card-subtitle class="pt-0">
          <template>
            {{ item.raw.enabled ? 'Enabled' : 'Disabled' }}
          </template>
          <template>
            &nbsp;
            {{
              item.raw.objectProperties.find(
                itemInner => itemInner.key === 'credentialsType'
              ).value
            }}
          </template>
          <template>
            &nbsp;
            {{
              convertBytes(
                item.raw.objectProperties.find(
                  itemInner => itemInner.key === 'credentialsSize'
                ).value
              )
            }}
          </template>
        </v-card-subtitle>
      </v-card>
    </v-hover>
    <template v-for="(item, index) in tabData.additionalItems">
      <v-list-item
        :key="index"
        @click="$emit('action', item)"
        v-if="item.action !== 'show-full-logs' && tabData.items.length <= 10"
      >
        <v-list-item-icon>
          <v-icon>{{ item.icon.name }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>
            {{ item.title }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </div>
</template>

<script>
import DropdownMenu from '@/components/DropdownMenu';
import useMedia from '@/compositions/useMedia';
import { ref } from '@vue/composition-api';
import ImageContainer from '@/components/app-entity/app-entity-tab/ImageContainer';

import convertBytes from '@/utils/convertBytes';

export default {
  name: 'AppEntityTabList',
  components: { ImageContainer, DropdownMenu },
  props: {
    tabData: {
      type: Object,
      default: () => ({})
    },
    isNestedEntity: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const mediaComposition = useMedia();

    const isErrorLoading = ref(false);

    const handleContext = (action, ctx) => {
      const eventPayload = {
        actionName: action,
        context: ctx,
        id: typeof ctx === 'string' ? ctx : ctx.id
      };
      context.emit('action', eventPayload);
    };
    const handleClickItem = item => {
      if (!props.isNestedEntity) {
        item.actionClickElement();
      }
    };
    const copyText = e => {
      context.root.$copyText(e).catch(err => {
        console.error(`Cannot copy: ${err}`);
      });
    };

    return {
      handleContext,
      copyText,
      handleClickItem,
      isErrorLoading,
      getImageById: mediaComposition.getImageById,
      convertBytes
    };
  }
};
</script>
